import type { WizardParkingChoice } from "./PermitContextProvider/types";
import { requiresUserDateTimeInput } from "./requiresUserDateTimeInput";

export const isChoiceIneligible = (choice: WizardParkingChoice): boolean => {
	const isUpcoming = !!choice.rangeStart && new Date(choice.rangeStart) > new Date();
	const isOutsideRecurringWindow = choice.availability === "outside-recurring-window";
	const isFull = choice.capacity === "full" && !requiresUserDateTimeInput(choice);
	return isUpcoming || isFull || isOutsideRecurringWindow;
};
